module.exports = __webpack_public_path__ + "media/images/help/flow/bg-dotted-c9442c90f8320dba6737e8301ce01bd5.svg";